import { Button, Stack, Box } from "@mui/material";
import { useContext } from "react";
import { Form, FormContext } from "components/shared/Form";
import DictionaryField from "components/ui/atoms/formFields/DictionaryField";

const sorts = [
  { label: "Newer added", value: "-created_at" },
  { label: "Older added", value: "created_at" },
  { label: "Newer updated", value: "-updated_at" },
  { label: "Older updated", value: "updated_at" },
];

const prepareInitialValues = (object) => ({
  ordering: object?.ordering || "",
});

const AsyncProcessesSortFormFields = () => {
  const { onSubmit } = useContext(FormContext);

  return (
    <Stack spacing={2}>
      <DictionaryField
        optionsDictionary={Object.fromEntries(
          sorts.map((x) => [x.value, x.label]),
        )}
        name="ordering"
        label="Order by"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onSubmit}>
          Apply
        </Button>
      </Box>
    </Stack>
  );
};

const AsyncProcessesSortForm = (props) => {
  return (
    <Form prepareInitialValues={prepareInitialValues} {...props}>
      <AsyncProcessesSortFormFields />
    </Form>
  );
};

export default AsyncProcessesSortForm;
